import React from 'react';
import { ShieldCheck, Heart, Leaf, Truck } from "lucide-react";
import { Link } from "react-router-dom";

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
// Import required modules
import { Pagination, Autoplay } from 'swiper/modules';

const WhyChooseUs = () => {
  const values = [
    {
      icon: <ShieldCheck className="w-8 h-8 text-pink-600" />,
      title: "Leak-Lock Protection",
      description: "Secure protection that stays in place through everyday movement.",
    },
    {
      icon: <Leaf className="w-8 h-8 text-pink-600" />,
      title: "Skin-Conscious Care",
      description: "No added chlorine, fragrances, or harsh bleaching agents.",
    },
    {
      icon: <Heart className="w-8 h-8 text-pink-600" />,
      title: "Rash-Free Comfort",
      description: "Feather-soft comfort designed for sensitive skin and long hours of wear.",
    },
    {
      icon: <Truck className="w-8 h-8 text-pink-600" />,
      title: "Smart Doorstep Delivery",
      description: "Flexible subscription plans so essentials reach you before you run out.",
    },
  ];

  return (
    <div className="bg-white">
      <section className="py-20 max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Why Choose Us?
          </h2>
          <div className="w-20 h-1 bg-pink-400 mx-auto"></div>
        </div>

        {/* Carousel Container */}
        <div className="pb-12"> {/* Added padding bottom for pagination dots */}
          <Swiper
            modules={[Pagination, Autoplay]}
            spaceBetween={20}
            slidesPerView={1}
            pagination={{ clickable: true }}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            breakpoints={{
              // when window width is >= 640px (tablet)
              640: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              // when window width is >= 1024px (desktop)
              1024: {
                slidesPerView: 3,
                spaceBetween: 30,
              },
            }}
            className="mySwiper"
          >
            {values.map((value, index) => (
              <SwiperSlide key={index} className="h-full">
                <div className="p-8 border border-pink-50 rounded-2xl hover:bg-pink-50 transition-colors group h-full flex flex-col items-start min-h-[250px]">
                  <div className="mb-4 transform group-hover:scale-110 transition-transform">
                    {value.icon}
                  </div>
                  <h3 className="text-xl font-bold mb-3 text-gray-800">
                    {value.title}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    {value.description}
                  </p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>

      {/* CSS to style Swiper pagination dots to match your theme */}
      <style dangerouslySetInnerHTML={{ __html: `
        .swiper-pagination-bullet-active {
          background: #db2777 !important; /* pink-600 */
        }
        .swiper-pagination {
          bottom: 0px !important;
        }
      `}} />

      {/* Optional: Movement Section */}
      <section className="py-20 text-center max-w-4xl mx-auto px-6">
        <h2 className="text-3xl font-bold text-gray-900 mb-6 font-serif">
          More Than Just a Product
        </h2>
        <p className="text-xl text-gray-600 leading-relaxed italic">
          "For every subscription purchased, we donate a month's supply of pads
          to girls in rural communities."
        </p>
        <div className="mt-10">
          <Link to="/packages" className="bg-pink-600 text-white px-8 py-3 rounded-full font-bold hover:bg-pink-700 transition-all shadow-lg inline-block">
            Join the Movement
          </Link>
        </div>
      </section>
    </div>
  );
};

export default WhyChooseUs;